
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-storage-policy",
      function () {
        return require("private-next-pages/data-storage-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-storage-policy"])
      });
    }
  